<form [formGroup]="form" class="space-y-8">
  <!-- Type Selection -->
  <div class="flex flex-col space-y-2">

    <beautyapp-select
      formControlName="type"
      [data]="treatmentTypes"
      displayMember="label"
      valueMember="type"
      placeholder="აირჩიეთ მკურნალობის ტიპი"
      label="მკურნალობის ტიპი"
      size="large"
      />
  </div>

  <!-- CLINICAL_DIAGNOSTIC -->
  @if (selectedType === 'CLINICAL_DIAGNOSTIC') {
    <div class="space-y-4">
      <h3 class="font-bold text-lg">
        კლინიკურ-დიაგნოსტიკური გამოკვლევა
      </h3>
      <div class="flex flex-col space-y-2">
        <label>NCSP</label>
        <nz-tree-select
          formControlName="ncspId"
          [nzNodes]="classificationCodeService.classificationNCSPCodes()"
          nzShowSearch
          nzPlaceHolder="Please select"
          nzVirtualHeight="300px"
          nzHideUnMatched="true"
          nzCheckStrictly="true"
          nzShowLine="true"
          nzSize="large"
        ></nz-tree-select>
      </div>
      <div class="flex flex-col space-y-2">
        <label>ICD10</label>
        <nz-tree-select
          formControlName="icd10Id"
          [nzNodes]="classificationCodeService.classificationICDCodes()"
          nzShowSearch
          nzPlaceHolder="Please select"
          nzVirtualHeight="300px"
          nzHideUnMatched="true"
          nzCheckStrictly="true"
          nzShowLine="true"
          nzSize="large"
        ></nz-tree-select>
      </div>
      <div class="flex flex-col space-y-2">
        <label>პროცედურის შედეგი</label>
        <textarea
          formControlName="procedureResult"
          class="border border-gray-300 rounded-lg p-2"
        ></textarea>
      </div>
    </div>
  }

  <!-- OTHER_ACTIVITY -->
  @if (selectedType === 'OTHER_ACTIVITY') {
    <div class="space-y-4">
      <h3 class="font-bold text-lg">თანმხლები აქტივობა</h3>
      <div class="flex flex-col space-y-2">
        <label>NCSP</label>
        <nz-tree-select
          formControlName="ncspId"
          [nzNodes]="classificationCodeService.classificationNCSPCodes()"
          nzShowSearch
          nzPlaceHolder="Please select"
          nzVirtualHeight="300px"
          nzHideUnMatched="true"
          nzCheckStrictly="true"
          nzShowLine="true"
          nzSize="large"
        ></nz-tree-select>
      </div>
      <div class="flex flex-col space-y-2">
        <label>ICD10</label>
        <nz-tree-select
          formControlName="icd10Id"
          [nzNodes]="classificationCodeService.classificationICDCodes()"
          nzShowSearch
          nzPlaceHolder="Please select"
          nzVirtualHeight="300px"
          nzHideUnMatched="true"
          nzCheckStrictly="true"
          nzShowLine="true"
          nzSize="large"
        ></nz-tree-select>
      </div>
      <div class="flex flex-col space-y-2">
        <label>პროცედურის შედეგი</label>
        <textarea
          formControlName="procedureResult"
          class="border border-gray-300 rounded-lg p-2"
        ></textarea>
      </div>
    </div>
  }

  <!-- LAB_TEST -->
  @if (selectedType === 'LAB_TEST') {
    <div class="space-y-4">
      <h3 class="font-bold text-lg">ლაბორატორიული გამოკვლევები</h3>
      <div class="flex flex-col space-y-2">
        <label>ლაბორატორია</label>
        <nz-tree-select
          formControlName="labCodeId"
          [nzNodes]="classificationCodeService.classificationLaboratoryCodes()"
          nzShowSearch
          nzPlaceHolder="Please select"
          nzVirtualHeight="300px"
          nzHideUnMatched="true"
          nzCheckStrictly="true"
          nzShowLine="true"
          nzSize="large"
        ></nz-tree-select>
      </div>
      <div class="flex flex-col space-y-2">
        <label>ლაბორატორიული კვლევის ტექსტი</label>
        <textarea
          formControlName="labExamText"
          class="border border-gray-300 rounded-lg p-2"
        ></textarea>
      </div>
      <div class="flex flex-col space-y-2">
        <label>პროცედურის შედეგი</label>
        <textarea
          formControlName="procedureResult"
          class="border border-gray-300 rounded-lg p-2"
        ></textarea>
      </div>
    </div>
  }

  @if (selectedType === 'CONSULTATION') {
    <div class="space-y-4">
      <h3 class="font-bold text-lg">კონსულტაციები</h3>
      <div class="flex flex-col space-y-2">
        <label>NCSP</label>
        <nz-tree-select
          formControlName="ncspId"
          [nzNodes]="classificationCodeService.classificationNCSPCodes()"
          nzShowSearch
          nzPlaceHolder="Please select"
          nzVirtualHeight="300px"
          nzHideUnMatched="true"
          nzCheckStrictly="true"
          nzShowLine="true"
          nzSize="large"
        ></nz-tree-select>
      </div>
      <div class="flex flex-col space-y-2">
        <label>ICD10</label>
        <nz-tree-select
          formControlName="icd10Id"
          [nzNodes]="classificationCodeService.classificationICDCodes()"
          nzShowSearch
          nzPlaceHolder="Please select"
          nzVirtualHeight="300px"
          nzHideUnMatched="true"
          nzCheckStrictly="true"
          nzShowLine="true"
          nzSize="large"
        ></nz-tree-select>
      </div>
      <div class="flex flex-col space-y-2">
        <beautyapp-select
          label="{{'users.column.medicalSpecialty' | translate}}"
          placeholder="{{'users.column.medicalSpecialty' | translate}}"
          [data]="medicalSpecialties"
          displayMember="value"
          valueMember="id"
          formControlName="specialtyCode"
          size="large"
          >
        </beautyapp-select>
      </div>
      <div class="flex flex-col space-y-2">
        <label>ექიმის სახელი</label>
        <input
          type="text"
          formControlName="consultantName"
          class="border border-gray-300 rounded-lg p-2"
          />
      </div>
      <div class="flex flex-col space-y-2">
        <beautyapp-datepicker
          formControlName="consultationDate"
          label="კონსულტაციის თარიღი"
          size="large"
          />
      </div>
      <div class="flex flex-col space-y-2">
        <label>კომენტარი</label>
        <textarea
          formControlName="consultationComment"
          class="border border-gray-300 rounded-lg p-2"
        ></textarea>
      </div>
    </div>
  }


  <!-- PRESCRIPTION -->
  @if (selectedType === 'PRESCRIPTION') {
    <div class="space-y-4">
      <h3 class="font-bold text-lg">დანიშნულება</h3>
      <div class="flex flex-col space-y-2">
        <label>ICD10</label>
        <nz-tree-select
          formControlName="icd10Id"
          [nzNodes]="classificationCodeService.classificationICDCodes()"
          nzShowSearch
          nzPlaceHolder="Please select"
          nzVirtualHeight="300px"
          nzHideUnMatched="true"
          nzCheckStrictly="true"
          nzShowLine="true"
          nzSize="large"
        ></nz-tree-select>
      </div>
      <div class="flex flex-col space-y-2">
        <button nz-button
          (click)="chooseDrug()"
          >
          მედიკამენტის არჩევა
        </button>
      </div>
      <div class="flex flex-col space-y-2">
        <label>მედიკამენტის ნომერი</label>
        <input
          type="text"
          formControlName="productId"
          class="border border-gray-300 rounded-lg p-2"
          readonly
          />
      </div>
      <div class="flex flex-col space-y-2">
        <label>მედიკამენტის სახელი</label>
        <input
          type="text"
          formControlName="drugName"
          class="border border-gray-300 rounded-lg p-2"
          />
      </div>
      <div class="flex flex-col space-y-2">
        <label>რაოდენობა</label>
        <input
          type="number"
          formControlName="drugCount"
          class="border border-gray-300 rounded-lg p-2"
          />
      </div>
      <div class="flex flex-col space-y-2">
        <label>
          გამოყენებული
        </label>
        <select
          formControlName="wasUsed"
          class="border border-gray-300 rounded-lg p-2"
          >
          <option [value]="1">მკურნალობის პროცესში</option>
          <option [value]="2">ანესტეზიისთვის</option>
        </select>
      </div>
    </div>
  }

  <!-- TRANSFUSION -->
  @if (selectedType === 'TRANSFUSION') {
    <div class="space-y-4">
      <h3 class="font-bold text-lg">სისხლის გადასხმა</h3>
      <div class="flex flex-col space-y-2">
        <label>სისხლის კომპონენტი</label>
        <nz-select formControlName="bloodComponent" nzSize="large">
          @for (blood of bloodComponents; track blood.value) {
            <nz-option [nzLabel]="blood.value" [nzValue]="blood.id"></nz-option>
          }
        </nz-select>
      </div>
      <div class="flex flex-col space-y-2">
        <label>ტრანსფუზიის ჩვენება</label>
        <input
          type="number"
          formControlName="indicationOfTransfusion"
          class="border border-gray-300 rounded-lg p-2"
          />
      </div>
      <div class="flex flex-col space-y-2">
        <label>რაოდენობა</label>
        <input
          type="number"
          formControlName="quantity"
          class="border border-gray-300 rounded-lg p-2"
          />
      </div>
      <div class="flex flex-col space-y-2">
        <label>ექიმის კომენტარი</label>
        <textarea
          formControlName="transfusionComment"
          class="border border-gray-300 rounded-lg p-2"
        ></textarea>
      </div>
    </div>
  }

  <!-- ANESTHESIA -->
  @if (selectedType === 'ANESTHESIA') {
    <div class="space-y-4">
      <h3 class="font-bold text-lg">ანესთეზიის ეპიზოდი</h3>
      <div class="flex flex-col space-y-2">
        <label>ICD10</label>
        <nz-tree-select
          formControlName="icd10Id"
          [nzNodes]="classificationCodeService.classificationICDCodes()"
          nzShowSearch
          nzPlaceHolder="Please select"
          nzVirtualHeight="300px"
          nzHideUnMatched="true"
          nzCheckStrictly="true"
          nzShowLine="true"
          nzSize="large"
        ></nz-tree-select>
      </div>
      <div class="flex flex-col space-y-2">
        <label>NCSP</label>
        <nz-tree-select
          formControlName="ncspId"
          [nzNodes]="classificationCodeService.classificationNCSPCodes()"
          nzShowSearch
          nzPlaceHolder="Please select"
          nzVirtualHeight="300px"
          nzHideUnMatched="true"
          nzCheckStrictly="true"
          nzShowLine="true"
          nzSize="large"
        ></nz-tree-select>
      </div>
      <div class="flex flex-col space-y-2">
        <label>კომენტარი</label>
        <textarea
          formControlName="anesthesiaComment"
          class="border border-gray-300 rounded-lg p-2"
        ></textarea>
      </div>
    </div>
  }

  <!-- SURGERY -->
  @if (selectedType === 'SURGERY') {
    <div class="space-y-4">
      <h3 class="font-bold text-lg">ქირურგიული ჩარევა</h3>
      <div class="flex flex-col space-y-2">
        <label>ICD10</label>
        <nz-tree-select
          formControlName="icd10Id"
          [nzNodes]="classificationCodeService.classificationICDCodes()"
          nzShowSearch
          nzPlaceHolder="Please select"
          nzVirtualHeight="300px"
          nzHideUnMatched="true"
          nzCheckStrictly="true"
          nzShowLine="true"
          nzSize="large"
        ></nz-tree-select>
      </div>
      <div class="flex flex-col space-y-2">
        <label>NCSP</label>
        <nz-tree-select
          formControlName="ncspId"
          [nzNodes]="classificationCodeService.classificationNCSPCodes()"
          nzShowSearch
          nzPlaceHolder="Please select"
          nzVirtualHeight="300px"
          nzHideUnMatched="true"
          nzCheckStrictly="true"
          nzShowLine="true"
          nzSize="large"
        ></nz-tree-select>
      </div>
      <div class="flex flex-col space-y-2">
        <label>ოქმის No</label>
        <input
          type="text"
          formControlName="protocolNo"
          class="border border-gray-300 rounded-lg p-2"
          />
      </div>
      <div class="flex flex-col space-y-2">
        <label>პროცედურის შედეგი</label>
        <textarea
          formControlName="procedureResult"
          class="border border-gray-300 rounded-lg p-2"
        ></textarea>
      </div>
    </div>
  }

  <!-- OPERATION_PROTOCOL -->
  @if (selectedType === 'OPERATION_PROTOCOL') {
    <div class="space-y-4">
      <h3 class="font-bold text-lg">ოპერაციის ოქმი</h3>
      <div class="flex flex-col space-y-2">
        <label>ოქმის No</label>
        <input
          type="text"
          formControlName="protocolNo"
          class="border border-gray-300 rounded-lg p-2"
          />
      </div>
      <div class="flex flex-col space-y-2">
        <label>ოქმის ტექსტი</label>
        <textarea
          formControlName="protocolText"
          class="border border-gray-300 rounded-lg p-2"
        ></textarea>
      </div>
    </div>
  }
</form>

<div *nzModalFooter>
  <button nz-button nzType="default" nzSize="large" (click)="modal.close()">{{ 'buttons.close' | translate }}</button>
  <button type="button" nz-button nzSize="large" nzType="primary" (click)="submit()">{{ 'buttons.save' | translate }}
  </button>
</div>
